import { Tour, TourStep, SelectedElement } from '../../../interfaces/tours';

export const initialContext = {
    currentTour: null as Tour | null,
    steps: [] as TourStep[],
    currentPath: '/' as string,

    selectionMode: false,
    selectedElement: null as SelectedElement | null,
    showStepForm: false,
    showCreateTour: false,
    isAddingStep: false,
    tourConfigured: false,

    loading: false,
    savingTour: false,
    loadingCountries: false,
    loadingWorkspaces: false,
    loadingMore: false,
    hasMore: true,

    countries: [],
    workspaces: [],
    tours: [] as Tour[],

    form: {} as any,

    stepSelected: null as TourStep | null,
    tourSelected: null as Tour | null,
    setStepSelected: () => { },
    setTourSelected: () => { },

    createTour: () => { },
    addStep: () => { },
    editStep: () => { },
    deleteStep: () => { },
    reorderSteps: () => { },
    toggleSelectionMode: () => { },
    selectElement: () => {},
    saveTour: () => Promise.resolve(),
    deleteTour: () => Promise.resolve(),
    fetchTours: () => { },
    setCurrentTour: () => { },
    setCurrentPath: () => { },
    setShowCreateTour: () => { },
    setShowStepForm: () => { },
    cancelStepForm: () => { },
    fetchCountries: () => { },
    resetTour: () => { },
    startAddingStep: () => { },
    cancelAddingStep: () => { },
    completeTourConfiguration: () => { },
    changeElementSelection: () => { },
    cancelAddingTour: () => {},
    fetchWorkspacesAsync: async () => ({ items: [], total: 0 }),
    updateTour: async () => { Promise.resolve(); },
    startEditingTour: () => { },
    fetchMoreTours: async () => { Promise.resolve(); },
};
